<div class="thinking-ui" [class.is-done]="state === 'done'">
  <button
    type="button"
    class="thinking-header"
    [class.clickable]="collapsible"
    (click)="toggle()"
    [attr.aria-expanded]="expanded"
  >
    <div class="left">
      <div class="status-icon">
        <ng-container *ngIf="state === 'thinking'; else doneIcon">
          <span class="dot dot-1"></span>
          <span class="dot dot-2"></span>
          <span class="dot dot-3"></span>
        </ng-container>

        <ng-template #doneIcon>
          <svg viewBox="0 0 24 24" class="check-icon" aria-hidden="true">
            <path
              d="M20 6L9 17l-5-5"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </ng-template>
      </div>

      <div class="text-block">
        <div class="title">
          {{ state === 'thinking' ? titleThinking : titleDone }}
        </div>

        <div class="subtitle" *ngIf="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <svg
      *ngIf="collapsible"
      class="chevron"
      [class.expanded]="expanded"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M6 9l6 6 6-6"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  <div class="thinking-body" *ngIf="expanded">
    <div class="thought-list" *ngIf="thoughts?.length; else emptyState">
      <div
        class="thought-item"
        *ngFor="let thought of thoughts; trackBy: trackByIndex"
      >
        {{ thought }}
      </div>
    </div>

    <ng-template #emptyState>
      <div class="empty-text">
        {{ state === 'thinking'
          ? 'Reasoning in progress...'
          : 'No detailed reasoning steps available.' }}
      </div>
    </ng-template>
  </div>
</div>

